import { create } from "zustand";
import { TServiceTicket } from "~/types";

interface CompleteTicketState {
  isOpen: boolean;
  ticket: TServiceTicket | null;
}

interface CompleteTicketActions {
  openCompleteTicket: (ticket?: TServiceTicket) => void;
  closeCompleteTicket: () => void;
}

export const useCompleteTicket = create<
  CompleteTicketState & CompleteTicketActions
>()((set) => ({
  isOpen: false,
  ticket: null,
  openCompleteTicket: (ticket?: TServiceTicket) =>
    set({
      isOpen: true,
      ticket,
    }),
  closeCompleteTicket: () =>
    set({
      isOpen: false,
      ticket: null,
    }),
}));
